import { Box } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { api_request } from "../../store/actions/commonAction";
import { API_METHOD_GET } from "../../config/constants";
import {
  SETTINGS_META_ERROR,
  SETTINGS_META_SUCCESS,
} from "../../store/types/commonTypes";

export default function NonProtectedContainer(props) {
  const location = useLocation();

  let uid = useSelector((state) => state?.auth?.uid);
  let nextUrl = useSelector((state) => state?.route?.nextUrl);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/settingMeta",
        {},
        {},
        null,
        SETTINGS_META_SUCCESS,
        SETTINGS_META_ERROR,
        false,
        false,
      ),
    );
  }, []);

  console.log("IN NON PROTECTED");
  console.log(nextUrl);

  if (uid) {
    return <Navigate to="/dashboard" />;
  } else if (
    location.pathname &&
    location.pathname !== nextUrl &&
    location.pathname !== "/" &&
    location.pathname !== "/account/delete" &&
    location.pathname !== "/account/delete/"
  ) {
    return <Navigate to={nextUrl} />;
  }

  return (
    <Box
      style={{
        minHeight: "100vh",
        minWidth: location.pathname !== "/" ? "100vw" : "calc(100vw - 24px)",
        marginLeft: location.pathname !== "/" ? "-24px" : null,
        // background:
        //   "linear-gradient(106.37deg, #ffe1bc 29.63%, #ffcfd1 51.55%, #f3c6f1 90.85% )",
      }}
    >
      {props.children}
    </Box>
  );
}
